// extracted by mini-css-extract-plugin
export var badge = "BestValueCard_badge__KGxAa";
export var badgeCenter = "BestValueCard_badgeCenter__hNrOi";
export var badgeLeft = "BestValueCard_badgeLeft__s2WnI";
export var badgeRight = "BestValueCard_badgeRight__BOF44";
export var billingData = "BestValueCard_billingData__PrtGr";
export var billingInformation = "BestValueCard_billingInformation__7sT6x";
export var priceWrapper = "BestValueCard_priceWrapper__gyw-j";
export var wrapper = "BestValueCard_wrapper__O1gF-";
export var wrapperBadge = "BestValueCard_wrapperBadge__m3bVG";
export var wrapperCenter = "BestValueCard_wrapperCenter__iWKdf";
export var wrapperLarge = "BestValueCard_wrapperLarge__hYtxv";
export var wrapperLeft = "BestValueCard_wrapperLeft__SXGxn";
export var wrapperList = "BestValueCard_wrapperList__JsX0g";